<template>
  <div class="float-buttons" v-if="whatsapp">
    <v-btn
      v-if="whatsapp"
      :href="whatsapp"
      target="_blank"
      color="#25D366"
      class="white--text"
      :height="xs ? 40 : 56"
      :width="xs ? 40 : 56"
      :min-width="xs ? 40 : 56"
      rounded
    >
      <v-icon :size="xs ? 18 : 28">fab fa-whatsapp </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";

export default {
  computed: {
    whatsapp() {
      if (!this.$rest("informations-contacts").item.whatsapp_float) return "";
      return getWhatsappLinkFromPhone(
        this.$rest("informations-contacts").item.whatsapp_float
      );
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
};
</script>

<style lang="scss" scoped>
.float-buttons {
  align-items: flex-end;
  bottom: 18px;
  display: flex;
  flex-direction: column;
  position: fixed;
  right: 18px;
  width: 0;
  z-index: 999;
}
</style>
